<template>
  <div class="questionBankDetails">
    <div class="topTitle clearfix" style="background-color:#0580CE;">
      <div style="cursor: pointer;" class="fl">
        <svg t="1666245291627" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3286" width="20" height="20">
          <path d="M438.4 849.1l222.7-646.7c0.2-0.5 0.3-1.1 0.4-1.6L438.4 849.1z" p-id="3287" fill="#ffffff"></path>
          <path d="M661.2 168.7h-67.5c-3.4 0-6.5 2.2-7.6 5.4L354.7 846c-0.3 0.8-0.4 1.7-0.4 2.6 0 4.4 3.6 8 8 8h67.8c3.4 0 6.5-2.2 7.6-5.4l0.7-2.1 223.1-648.3 7.4-21.4c0.3-0.8 0.4-1.7 0.4-2.6-0.1-4.5-3.6-8.1-8.1-8.1zM954.6 502.1c-0.8-1-1.7-1.9-2.7-2.7l-219-171.3c-3.5-2.7-8.5-2.1-11.2 1.4-1.1 1.4-1.7 3.1-1.7 4.9v81.3c0 2.5 1.1 4.8 3.1 6.3l115 90-115 90c-1.9 1.5-3.1 3.8-3.1 6.3v81.3c0 4.4 3.6 8 8 8 1.8 0 3.5-0.6 4.9-1.7l219-171.3c6.9-5.4 8.2-15.5 2.7-22.5zM291.1 328.1l-219 171.3c-1 0.8-1.9 1.7-2.7 2.7-5.4 7-4.2 17 2.7 22.5l219 171.3c1.4 1.1 3.1 1.7 4.9 1.7 4.4 0 8-3.6 8-8v-81.3c0-2.5-1.1-4.8-3.1-6.3l-115-90 115-90c1.9-1.5 3.1-3.8 3.1-6.3v-81.3c0-1.8-0.6-3.5-1.7-4.9-2.7-3.5-7.7-4.1-11.2-1.4z" p-id="3288" fill="#ffffff"></path>
        </svg>
        <span style="color:white;font-size:20px;font-weight: 500;margin-left:10px;">C/C++编辑器</span>
      </div>
      <div style="cursor: pointer;" class="fr">
        <div @click="goback" style="margin-top:-5px">
          <svg t="1666238301833" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11675" width="32" height="32">
            <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="11676" fill="#ffffff"></path>
            <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="11677" fill="#ffffff"></path>
            <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="11678" fill="#ffffff"></path>
          </svg>
        </div>
        <!-- <span style="color:white;font-size:20px;font-weight: 500;" @click="goback">返回</span> -->
      </div>
    </div>
    <div class="main">
      <el-row>

        <el-col :span="24">
          <div class="main-right">
            <CodeMirror class="editor" :style="{height: scrollerHeight}" :code="code" :arr1="arr1" :language="language" @cdata="oncdata" @changeLang="onChangeLang" @handleFullScreen1='handleFullScreen1'></CodeMirror>

            <div class="Console" v-if="isshow2">
              <el-tabs type="border-card" v-model="activeName1">
                <el-tab-pane label="测试用例" name="first1">
                  <el-input type="textarea" resize='none' v-model="desc" :autosize="{ minRows: 5, maxRows: 5}">
                  </el-input>
                </el-tab-pane>
                <el-tab-pane label="代码执行结果" name="second1">
                  执行结果:
                  <div v-if="result1 === 0">
                    <div style="margin-top:10px">
                      <el-alert style="white-space:pre" v-html="output" type="success">
                      </el-alert>
                    </div>
                  </div>
                  <span v-if="result1 === -1">程序输出不正确</span>
                  <span style="color: #8F2624;" v-if="result1 === 1">时间超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 2">时间超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 3">内存超限</span>
                  <span style="color: #8F2624;" v-if="result1 === 4">程序运行错误</span>
                  <span style="color: #8F2624;" v-if="result1 === 5">系统错误</span>
                  <span style="color: #8F2624;" v-if="result1 === -2">编译失败</span>
                  <span style="color: #8F2624;" v-if="result1 === 6">等待测评</span>
                  <span style="color: #8F2624;" v-if="result1 === 7">测评中</span>
                  <span v-if="result1 === 8">部分输出正确</span>
                  <div v-if="result1 === -2 ? true:false" style="margin-top:10px" class="weeor">
                    <el-alert :title="error_info" type="error">
                    </el-alert>
                  </div>
                  <div v-if="result1 === 4 ? true:false" style="margin-top:10px" class="weeor">
                    <el-alert :title="error_info1" type="error">
                    </el-alert>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>

            <div :style="{margin: marginTop}">
              <div class="clearfix" style="position: relative; z-index: 10;">
                <div class="fl">

                  <el-button type="text" style="color:#606266;margin-right:10px" size="small" @click="Console" :disabled="disabled1">控制台
                    <span v-if="isshow2 === false" class="el-icon-caret-bottom"></span>
                    <span v-else class="el-icon-caret-top"></span>
                  </el-button>
                  <el-dropdown trigger="click" v-if="isshow2" class="select" style="display:none;">
                    <span class="el-dropdown-link" ref="ellink">
                      <span style="font-size:12px; cursor: pointer;color:#0A84FF">填入示例<i class="el-icon-arrow-down el-icon--right" /></span>
                    </span>
                    <el-dropdown-menu slot="dropdown" align="center">
                      <el-dropdown-item v-for="(item ,index) in samples" :key="index" style="padding:0 10px 0 10px;text-align: left;" @click.native="ChangeSamples(item.input)">
                        样例{{index +1}} <span style="margin-left:10px;color:#ccc">{{ item.input}}</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>

                </div>

                <div class="fr">
                  <el-button-group style="">
                    <el-button size="" type="" :disabled="disabled1" @click="GoSubmitRecords">提交记录</el-button>
                    <el-button size="" type="primary" @click="test" :disabled="disabled1" :loading="disabled2">运行程序</el-button>
                  </el-button-group>

                </div>
              </div>
            </div>
          </div>

          <el-dialog title="编译信息" :visible.sync="dialogVisible" width="30%">
            <span style="color:#F56C6C">{{ errrorInfo }}</span>
          </el-dialog>

        </el-col>

      </el-row>

    </div>
    <el-drawer :with-header="false" :visible.sync="drawer" direction="rtl" size="50%">

      <div style="padding:20px;">
        <el-table size="mini" :data="tableData" stripe style="width: 100%" :header-cell-style="{ background: 'white', color: '#909399' }">
          <el-table-column type="index" label="序号">
            <template slot-scope="scope">
              <span>{{ scope.$index + 1 + (page_no - 1) * page_size }}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.result === -1">
                <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === 0">
                <svg t="1658296902087" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13040" width="15" height="15">
                  <path d="M0 0h1024v1024H0V0z" fill="#202425" opacity=".01" p-id="13041"></path>
                  <path d="M955.733333 512c0 245.077333-198.656 443.733333-443.733333 443.733333S68.266667 757.077333 68.266667 512 266.922667 68.266667 512 68.266667s443.733333 198.656 443.733333 443.733333z" fill="#11AA66" p-id="13042"></path>
                  <path d="M512 102.4C285.7984 102.4 102.4 285.7984 102.4 512s183.3984 409.6 409.6 409.6 409.6-183.3984 409.6-409.6S738.2016 102.4 512 102.4zM34.133333 512C34.133333 248.081067 248.081067 34.133333 512 34.133333s477.866667 213.947733 477.866667 477.866667-213.947733 477.866667-477.866667 477.866667S34.133333 775.918933 34.133333 512z" fill="#11AA66" p-id="13043"></path>
                  <path d="M787.114667 339.285333a51.2 51.2 0 0 1 0 72.362667l-307.2 307.2a51.2 51.2 0 0 1-72.362667 0l-170.666667-170.666667a51.2 51.2 0 0 1 72.362667-72.362666L443.733333 610.235733l271.018667-271.018666a51.2 51.2 0 0 1 72.362667 0z" fill="#FFFFFF" p-id="13044"></path>
                </svg></span>
              <span v-if="scope.row.result === 1">
                <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === 2">
                <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === 3">
                <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === 4">
                <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === 5"> <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === -2">
                <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === 6">
                <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === 7">
                <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>
              <span v-if="scope.row.result === 8"> <svg t="1658296992015" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="13965" width="15" height="15">
                  <path d="M827.392 195.584q65.536 65.536 97.792 147.456t32.256 167.936-32.256 167.936-97.792 147.456-147.456 98.304-167.936 32.768-168.448-32.768-147.968-98.304-98.304-147.456-32.768-167.936 32.768-167.936 98.304-147.456 147.968-97.792 168.448-32.256 167.936 32.256 147.456 97.792zM720.896 715.776q21.504-21.504 18.944-49.152t-24.064-49.152l-107.52-107.52 107.52-107.52q21.504-21.504 24.064-49.152t-18.944-49.152-51.712-21.504-51.712 21.504l-107.52 106.496-104.448-104.448q-21.504-20.48-49.152-23.04t-49.152 17.92q-21.504 21.504-21.504 52.224t21.504 52.224l104.448 104.448-104.448 104.448q-21.504 21.504-21.504 51.712t21.504 51.712 49.152 18.944 49.152-24.064l104.448-104.448 107.52 107.52q21.504 21.504 51.712 21.504t51.712-21.504z" p-id="13966" fill="#d81e06"></path>
                </svg></span>

            </template>
          </el-table-column>

          <el-table-column label="语言">
            <template slot-scope="scope">
              <span v-if="scope.row.language === 0">C</span>
              <span v-if="scope.row.language === 1">C++</span>
              <span v-if="scope.row.language === 2">Python3</span>

            </template>
          </el-table-column>
          <el-table-column label="耗时">
            <template slot-scope="scope">
              <span>{{ scope.row.cpu_time }}ms</span>
            </template>
          </el-table-column>
          <el-table-column label="内存">
            <template slot-scope="scope">
              <span>{{ scope.row.memory / 1024 }}kb</span>
            </template>
          </el-table-column>

          <el-table-column prop="created_time" label="提交时间" width="200">
          </el-table-column>
          <el-table-column label="状态" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.result === -1">程序输出不正确</span>
              <span v-if="scope.row.result === 0">程序输出正确</span>
              <span v-if="scope.row.result === 1">超时</span>
              <span v-if="scope.row.result === 2">超时</span>
              <span v-if="scope.row.result === 3">内存超限</span>
              <span v-if="scope.row.result === 4">程序运行错误</span>
              <span v-if="scope.row.result === 5">系统错误</span>
              <span v-if="scope.row.result === -2">编译失败</span>
              <span v-if="scope.row.result === 6">等待测评</span>
              <span v-if="scope.row.result === 7">测评中</span>
              <span v-if="scope.row.result === 8">部分输出正确</span>

            </template>
          </el-table-column>

        </el-table>

      </div>
      <div style="margin: 20px; text-align: right">
        <el-pagination @current-change="handleCurrent" :current-page="page_no" :page-size="page_size" :total="total">
        </el-pagination>
      </div>
    </el-drawer>

    <!-- 题解 -->
    <el-drawer title="题目解析" :visible.sync="drawer1" direction="ltr" size="90%">
      <analysis ref="Analysis" :problem_id="problem_id" :code1="detailsFrom.code" :title1="detailsFrom.title" />
    </el-drawer>

  </div>

</template>
    
<script>
import CodeMirror from "@/pages/OJ/components/CodeMirror";
import analysis from "../teach-lessons/components/analysis.vue";

import {
  getUserOjSubmissionList,
  createRunRecord,
  getOjRunRecordInfo,
  tchGetTchCppLessonOjProblemList,
  tchGetStuOjSubmissionList,
  recordList
}
  from "@/api/educational.js";

import Prism from 'prismjs'

export default {
  components: {
    CodeMirror,
    analysis
  },
  data() {
    return {
      isShow7: true,

      drawer1: false,
      lecturesTitle: '',
      contest_id: '',
      currentIndex: 0,
      ids: [],
      error_info: '',
      error_info1: '',
      result1: null,
      activeName1: 'first1',
      output: '',
      intervalcounter1: 0,
      runRecordId: '',

      SamplesTxt: null,
      scrollerHeight: 'calc(100vh - 149px) !important',
      marginTop: '25px 20px 16px 20px',
      isshow2: false,
      desc: "",
      dialogVisible1: false,

      textInfo: [],
      textInfo1: [],

      textInfo2: [],

      page_no: 1,
      page_size: 20,
      total: 20,
      tableData5: [],
      drawer: false,
      intervalcounter: 0,
      isshow1: false,
      ioiUserCoutestProblemSubmissionCount: '',
      errrorInfo: '',
      tableData: [],
      result: null,
      msg: '',
      clearTimeSet: null,
      disabled1: false,
      disabled2: false,

      problem_id: '',
      samples: [],
      detailsFrom: {},
      num: 8,
      num2: 16,
      languagesList: [],
      arr1: [],
      languages1: [
        {
          id: '0',
          label: 'c'
        },
        {
          id: '1',
          label: 'c++'
        },
        {
          id: "2",
          label: "Python3",
        },
      ],

      code: '',
      language: '0',
      submissionId: 0,
      dialogVisible: false
    }
  },
  watch: {
    'code'(newVal, oldVal) {
      console.log(newVal, 222344)
      console.log(oldVal, 222344)
    }
  },
  created() {
    this.info()
  },
  mounted() {
  },
  methods: {
    goback() {
      this.$confirm('是否确认返回?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.go(-1)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });

    },
    //初始化语言
    info() {
      this.languagesList = []
      this.arr1 = []
      let languagesId = JSON.stringify(['0', '1'])
      console.log(languagesId, 123456789)
      this.languagesList = JSON.parse(languagesId)
      this.languagesList.sort()
      this.language = this.languagesList[1]
      this.languagesList.map((item) => {
        console.log(item, 12346)
        let obj = this.languages1.find(function (e) {
          return e.id === item
        })
        console.log(obj, 1474411)
        this.arr1.push(obj)
      })
      this.$nextTick(() => {
        Prism.highlightAll()
      })
    },


    tchGetTchCppLessonOjProblemList() {
      tchGetTchCppLessonOjProblemList({
        lesson_id: this.$route.query.lesson_id,
        type: this.$route.query.type,
      }).then((res) => {
        this.ids = res.cppLessonOjProblemRelationList.map((item, index) => {
          return Object.assign({}, { id: item.oj_problem_id, num: index + 1 })
        })
        this.problem_id = this.ids[0].id
        console.log(this.problem_id, 1245);
        // res.cppLessonOjProblemRelationList.map((item) => {
        //   this.contest_id = item.curriculum_id
        //   console.log(item, 1245);

        // })
        this.$nextTick(() => {

          if (this.$route.query.userType === 'tch') {
            this.getOjProblemInfoById()
            this.getUserOjSubmissionList()

          }
          if (this.$route.query.userType === 'stu') {
            this.getOjProblemInfoById()
            this.tchGetStuOjSubmissionList()
            // 

          }


        })

        console.log(res, 4578)

      })

    },
    goTopicAnalysis() {
      this.drawer1 = true
      console.log(this.problem_id, 458)
      this.$refs.Analysis.search()
    },

    Console() {
      this.isshow2 = !this.isshow2
      if (this.isshow2 === true) {
        this.scrollerHeight = 'calc(100vh - 339px) !important'
        this.marginTop = '27px 20px 16px 20px'
      } else {
        this.scrollerHeight = 'calc(100vh - 149px) !important'
        this.marginTop = '25px 20px 16px 20px'
      }
      this.desc = this.samples[0].input

    },
    ChangeSamples(val) {
      console.log(val, 125)
      this.desc = val
    },
    AddInputSample() {
      console.log(this.samples, 2223)
    },
    test() {
      this.isshow2 = true
      if (this.isshow2 === true) {
        this.scrollerHeight = 'calc(100vh - 339px) !important'
        this.marginTop = '27px 20px 16px 20px'
      } else {
        this.scrollerHeight = 'calc(100vh - 149px) !important'
        this.marginTop = '25px 20px 16px 20px'
      }
      if (this.code === '') {
        this.$message.warning('代码不能为空')
        return false
      }
      createRunRecord({
        code: this.code,
        language: this.language,
        input: this.desc
      }).then((res) => {
        this.runRecordId = res.data.runRecordId
        console.log(this.runRecordId, 22354)
        this.$nextTick(() => {
          this.getOjRunRecordInfo()
        })
      })

    },
    getOjRunRecordInfo() {
      getOjRunRecordInfo({
        run_record_id: this.runRecordId
      }).then((res) => {
        clearInterval(this.clearTimeSet1);
        if (res.runRecordInfo.result === 6 || res.runRecordInfo.result === 7) {
          this.intervalcounter1++
          this.disabled1 = true
          this.disabled2 = true
          console.log(this.intervalcounter1, 123456)
          this.clearTimeSet1 = setInterval(this.getOjRunRecordInfo, 1000);

          if (this.intervalcounter1 === 20) {

            clearInterval(this.clearTimeSet1);
            this.$message.warning('判题超时')
            this.disabled1 = false
            this.disabled2 = false
          }
          console.log(this.intervalcounter1, 123456);
        } else {
          this.disabled1 = false
          this.disabled2 = false

          clearInterval(this.clearTimeSet1);
          this.intervalcounter1 = 0
          let aa = res.runRecordInfo.output.replace(/\n/g, "<br>");

          this.output = aa
          console.log(res.runRecordInfo.output, 45878);

          this.activeName1 = 'second1'
          this.result1 = res.runRecordInfo.result
          this.error_info1 = res.runRecordInfo.output
          this.error_info = res.runRecordInfo.error_info




          // this.result = res.submission.result
          // console.log(this.result, 222222222222)
          console.log(res, 123465)
        }

      })

    },


    onChangeLang(newLang) {
      console.log(newLang, 1545);
      this.language = newLang
    },
    oncdata(val) {
      this.code = val
    },

    tchGetStuOjSubmissionList() {
      tchGetStuOjSubmissionList({
        language: '1',
        problem_id: this.problem_id,
        stuId: this.$route.query.stu_id,
        page_no: this.page_no,
        page_size: this.page_size

      }).then((res) => {
        console.log(res)
        this.tableData = res.submissionList
        if (this.tableData.length > 0) {
          this.code = res.submissionList[0].code

          this.tableData.map((item) => {
            console.log(item, 121454)
            this.language = item.language.toString()
          })
        } else {
          if (this.language === '0') {
            console.log(JSON.parse(this.detailsFrom.template)[0], 111)
            if ('0' in JSON.parse(this.detailsFrom.template)) {
              this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1]
            } else {
              this.code = ''
            }
            // this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

          }

          if (this.language === '1') {
            if ('1' in JSON.parse(this.detailsFrom.template)) {
              this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1]
            } else {
              this.code = ''
            }
            // this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';


          }
          if (this.language === '2') {
            if ('2' in JSON.parse(this.detailsFrom.template)) {
              this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1]
            } else {
              this.code = ''
            }
            //this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

          }

        }

      })
    },

    getUserOjSubmissionList() {
      getUserOjSubmissionList({
        language: '1',
        problem_id: this.problem_id,
        page_no: this.page_no,
        page_size: this.page_size,
        contest_id: this.contest_id

      }).then((res) => {
        console.log(res)
        this.tableData = res.submissionList
        if (this.tableData.length === 0) {
          this.code = ''
          console.log(this.code, 666);


        }
        if (this.tableData.length > 0) {
          this.code = this.tableData[0].code

          this.tableData.map((item) => {
            console.log(item.language, 121454)

            this.language = item.language.toString()
          })
        } else {
          if (this.language === '0') {
            console.log(JSON.parse(this.detailsFrom.template)[0], 111)
            if ('0' in JSON.parse(this.detailsFrom.template)) {
              this.code = JSON.parse(this.detailsFrom.template)[0].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1]
            } else {
              this.code = ''
            }
          }

          if (this.language === '1') {
            console.log('aaaaaa', 666);
            console.log(JSON.parse(this.detailsFrom.template), 666);

            if ('1' in JSON.parse(this.detailsFrom.template)) {
              this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1]
              console.log(this.code, 666);
            } else {
              this.code = ''
            }
            // this.code = JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[1].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';


          }
          if (this.language === '2') {
            if ('2' in JSON.parse(this.detailsFrom.template)) {
              this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1]
            } else {
              this.code = ''
            }
            //this.code = JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] ? JSON.parse(this.detailsFrom.template)[2].match(/\/\/TEMPLATE BEGIN\n([\s\S]+?)\/\/TEMPLATE END/)[1] : '';

          }

        }

      })
    },
    GoSubmitRecords() {
      console.log(this.language, 78787);
      if (this.language === '0') {
        recordList({
          language: '0',
          page_no: this.page_no,
          page_size: this.page_size
        }).then((res) => {
          console.log(res)
          this.tableData = res.runRecordList
          this.total = res.total
        })
      }
      if (this.language === '1') {
        recordList({
          language: '1',
          page_no: this.page_no,
          page_size: this.page_size
        }).then((res) => {
          console.log(res)
          this.tableData = res.runRecordList
          this.total = res.total
        })
      }


      this.drawer = true

    },
    handleCurrent(val) {
      this.page_no = val
      if (this.language === '0') {
        recordList({
          language: '0',
          page_no: this.page_no,
          page_size: this.page_size
        }).then((res) => {
          console.log(res)
          this.tableData = res.runRecordList
          this.total = res.total
        })
      }
      if (this.language === '1') {
        recordList({
          language: '1',
          page_no: this.page_no,
          page_size: this.page_size
        }).then((res) => {
          console.log(res)
          this.tableData = res.runRecordList
          this.total = res.total
        })
      }


    },


    // changeLang:()


    handleFullScreen1() {
      if (this.num2 === 16) {
        this.num = 0
        this.num2 = 24
      } else {
        this.num = 8
        this.num2 = 16
      }
    },
    // 全屏方法
    handleFullScreen() {

      if (this.num === 8) {
        this.num = 24
        this.num2 = 0
      } else {
        this.num = 8
        this.num2 = 16
      }

    },



  }

}
</script>
    
<style lang="scss" scoped>
/deep/.el-drawer__header {
  display: none;
}

.box1 {
  border: 1px solid #1fb26e;
  padding: 15px;
}

.questionBankDetails {
  width: 100%;
  background: #ecf1f8;
}

.topTitle {
  height: 60px;
  background: #fff;
  padding: 20px;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;

  span {
    color: rgba(0, 0, 0, 0.45);
  }
}

.main {
  height: calc(100vh - 170px);
  border-radius: 5px;
  box-sizing: border-box;
  // overflow: hidden;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:after {
  content: "";
  display: block;
  visibility: hidden;
  clear: both;
}

.main_top ul {
  width: 100%;
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 10px;
}

.main_top {
  text-align: center;
}

.main_top li {
  float: left;
  width: 25%;
}

.txt1 {
  color: #909399;
  font-size: 14px;
  font-weight: bold;
}

.txt2 {
  color: rgba(166, 166, 166, 1);
  font-size: 14px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

.main-left {
  height: 100%;
  background: #fff;
  padding: 20px;
  height: calc(100vh - 79px);
  box-sizing: border-box;
  overflow-y: auto;
}

.main_cotton div {
  margin-top: 20px;
}

.txt3 {
  font-size: 16px;
  font-weight: bold;
}

.txt4 {
  font-size: 16px;
  font-weight: bold;
  color: #6c91f2;
}

.main-right {
  background: #fff;

  padding-top: 0px;
  padding-right: 0px;
  padding-left: 0px;

  height: calc(100vh - 79px);
  box-sizing: border-box;
  overflow-y: hidden;
}

.editor {
  // height: 90% !important;
}

.main_top ::v-deep .el-icon-monitor:before {
  color: #000;
}

.sample-input {
  width: 45%;
  margin-right: 5%;
}

.main_msg /deep/ .el-alert {
  padding: 5px 16px;
  margin-left: 20px;
}

.main_msg /deep/ .el-alert__closebtn {
  top: 9px;
  right: 8px;
}

/deep/ .main_cotton img {
  max-width: 100%;
}

/deep/.main_cotton ul {
  list-style: auto;
  list-style-type: initial;
  margin-left: 20px;
}

/deep/.main_cotton ol {
  list-style: auto;
  list-style-type: decimal;
  margin: auto;
  padding: auto;
  margin-left: 20px;
}

.Console {
}

// /deep/ .CodeMirror {
//   height: calc(100vh - 230px) !important;
// }
// .CodeMirror1 {
//   height: calc(100vh - 500px) !important;
// }
/deep/ .vue-codemirror {
  height: 100%;
}

/deep/ .cm-s-monokai.CodeMirror {
  height: 98% !important;
}

/deep/ .weeor .el-alert__content {
  padding: 0px;
}

/deep/ .weeor .el-icon-close:before {
  content: "";
}

/deep/ #pane-second1 {
  height: 117px;
  overflow-y: auto;
}

/deep/ .el-tabs--border-card {
  box-shadow: none;
}

.btn {
  width: 35px;
  text-align: center;
  // padding: 2px 10px;
  border: white 1px solid;
  cursor: pointer;
  margin-right: 10px;
  border-radius: 5px;
  color: white;
}

.active {
  color: #333;
  background-color: white;
}

/deep/ .el-icon-monitor:before {
  content: "";
}
</style>
    
    